<template>
  <div class="account-notifications">
    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
        <tr>
          <th width="200">DATE</th>
          <th>JOB</th>
        </tr>
        </thead>
        <tbody>
        <template v-if="relatedComments.length" >
          <tr v-for="(comment, index) in relatedComments" :key="index" :class="{'unread': !comment.pivot.read}" @click="read(index)" style="cursor: pointer;">
            <td>{{ comment.updated_at | toHumanDate('HH:mm, Do MMM YYYY') }}</td>
            <td>#{{ comment.object.id + ' - ' + comment.object.name }}</td>
          </tr>
        </template>
        <tr v-else-if="!loading"><td colspan="2">No notifications</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import ServiceUser from '@/services/user'

  export default {
    data () {
      return {
        loading: false,
        relatedComments: []
      }
    },
    watch: {},
    computed: {},
    mounted () {
      this.init();
    },
    methods: {
      init() {
        this.getRelatedComments();
      },
      getRelatedComments() {
        let self = this;
        self.loading = true;
        ServiceUser.getRelatedComments(resp => {
          self.relatedComments = resp;
        });
      },
      read(index) {
        let self = this;
        self.loading = true;
        ServiceUser.updateComment(self.relatedComments[index].id, {read: 1}, comment => {
          self.relatedComments[index].pivot.read = 1;
          self.$store.dispatch('GET_NOTIFICATIONS');
          self.$router.push({
            name: 'job',
            params: {
              jobId: comment.object_id
            }
          });
        });
      }
    }
  }
</script>
